import DOMPurify from 'dompurify';

const ALLOWED_TAGS = ['a', 'p', 'br', 'strong', 'em', 'b', 'i', 'ul', 'ol', 'li'];
const ALLOWED_ATTR = ['href', 'rel', 'target'];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.nodeName !== 'A') {
        return;
    }
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
    const href = node.getAttribute('href');
    if (href && !/^https?:/i.test(href)) {
        node.removeAttribute('href');
    }
});

export function escapeHtml(text: string): string {
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/** HTML notifiche: solo tag allowlist, niente script / javascript: / URL relativi. */
export function sanitizeNotificationHtml(dirty: string): string {
    const cleaned = String(
        DOMPurify.sanitize(dirty, {
            ALLOWED_TAGS,
            ALLOWED_ATTR,
            ALLOW_DATA_ATTR: false,
            ALLOWED_URI_REGEXP: /^(?:https?:)/i,
        }),
    );
    const lower = cleaned.toLowerCase();
    if (!lower.includes('<br') && !lower.includes('<p')) {
        return cleaned.replace(/\r\n/g, '\n').replace(/\n/g, '<br>\n');
    }
    return cleaned;
}

export function formatNotificationDateTime(iso: string | null | undefined): {
    text: string;
    datetime: string;
} | null {
    if (!iso) {
        return null;
    }
    const messageDate = new Date(iso);
    if (Number.isNaN(messageDate.getTime())) {
        return null;
    }
    return {
        text: messageDate.toLocaleString('it-IT'),
        datetime: messageDate.toISOString(),
    };
}

export function notificationListItemHtml(item: {
    testo?: string | null;
    data?: string | null;
}): string {
    const when = formatNotificationDateTime(item?.data);
    const dateHtml = when
        ? `<time class="date" datetime="${escapeHtml(when.datetime)}">${escapeHtml(when.text)}</time>`
        : '';
    const txt = sanitizeNotificationHtml(item?.testo || '');
    return `<li>${dateHtml}<div class="notif-body">${txt}</div></li>`;
}
